import * as C from '../styles';
import * as S from './styles';

import PanelOptionMixin from '../../options/mixin';
import HideIcon from '@svgIcons/hide_filter.svg';
import Checkbox from '@/components/Common/Checkbox';

import { WIDGET_TYPES } from '@/utils/consts';
import {
    DefaultDropdownBox,
    SelectedBox,
} from '@/components/Common/DropdownBox';
import InputField from '@/components/Common/InputField';
import { ADVANCED_METRIC_FILTER } from '../..';
import { fixedComma } from '@/utils/utils';
import { getFieldLocale } from '@/utils/field';

const METRIC_FILTER_LIST = ['spend', 'impressions', 'clicks'];
const { PIVOT_TABLE, PIVOT_TABLE_ANALYTIC } = WIDGET_TYPES;

const GREATER_THAN = {
    sign: '≤',
    value: 'GREATER_THAN',
};

const LESS_THAN = {
    sign: '≥',
    value: 'LESS_THAN',
};

const OPERATORS = [GREATER_THAN, LESS_THAN];

const SIGN_MAP_BY_VALUE = R.indexBy(R.prop('value'), OPERATORS);

const DEFAULT_VALUE = {
    operator: 'GREATER_THAN',
    value: 0,
};

export default {
    name: 'MetricFilterOption',
    mixins: [PanelOptionMixin],
    data() {
        return {
            dropdownVisibleMap: METRIC_FILTER_LIST.reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {}),
        };
    },
    props: {
        advancedMetricFilters: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    computed: {
        selectedFields: R.compose(
            R.filter(R.identity),
            R.pluck('field'),
            R.propOr([], 'currentList')
        ),
        advancedOptionValueMap: R.compose(
            R.indexBy(R.prop('field')),
            R.propOr([], 'advancedMetricFilters')
        ),
    },
    methods: {
        setDropdownMap({ key, value }) {
            this.dropdownVisibleMap = R.assoc(
                key,
                value,
                this.dropdownVisibleMap
            );
        },
        toggleFiltersByField(field) {
            const { currentList, selectedFields } = this;

            const isAlreadyAdded = R.includes(field, selectedFields);

            const filter = {
                field,
                ...DEFAULT_VALUE,
            };
            const filters = isAlreadyAdded
                ? R.reject(R.propEq('field', field), currentList)
                : R.append(filter, currentList);
            this.$emit('update', filters);
        },
        toggleAdvancedOptions(field) {
            const { advancedMetricFilters } = this;

            const isAlreadyAdded = R.any(
                R.propEq('field', field),
                advancedMetricFilters
            );

            const filter = {
                field,
                ...DEFAULT_VALUE,
            };

            const updatedAdancedFIlters = isAlreadyAdded
                ? R.reject(R.propEq('field', field), advancedMetricFilters)
                : R.append(filter, advancedMetricFilters);

            this.$emit('updateByKey', {
                key: ADVANCED_METRIC_FILTER,
                value: updatedAdancedFIlters,
            });
        },
        updateAdvancedOptionsValue(value) {
            const { advancedMetricFilters } = this;
            const { field } = value;

            const index = R.findIndex(
                R.propEq('field', field),
                advancedMetricFilters
            );

            const updatedAdancedFIlters = R.set(
                R.lensIndex(index),
                value,
                advancedMetricFilters
            );

            this.$emit('updateByKey', {
                key: ADVANCED_METRIC_FILTER,
                value: updatedAdancedFIlters,
            });
        },
        renderBasicOptions() {
            const { toggleFiltersByField, selectedFields } = this;
            return (
                <S.BasicOptionsWrapper>
                    <S.BasicOptionTitle>
                        {this.$t('NEW_DASHBOARD.hiding_zero_value')}
                    </S.BasicOptionTitle>
                    <S.BasicOptionsMetricWrappert>
                        {METRIC_FILTER_LIST.map((field) => (
                            <S.ItemWrapper
                                onClick={() => toggleFiltersByField(field)}
                            >
                                <Checkbox
                                    value={R.includes(field, selectedFields)}
                                />
                                <div>{getFieldLocale.call(this, field)}</div>
                            </S.ItemWrapper>
                        ))}
                    </S.BasicOptionsMetricWrappert>
                </S.BasicOptionsWrapper>
            );
        },
        renderAdvancedOptions() {
            return (
                <S.AdvancedWrapper>
                    {METRIC_FILTER_LIST.map(this.renderAdvancedOptionItem)}
                </S.AdvancedWrapper>
            );
        },
        renderAdvancedOptionItem(field) {
            const value = this.advancedOptionValueMap[field];
            const active = Boolean(value);

            return (
                <S.AdvancedItemWrapper>
                    <Checkbox
                        value={active}
                        onInput={() => this.toggleAdvancedOptions(field)}
                    />
                    <SelectedBox
                        selectedOption={getFieldLocale.call(this, field)}
                        disabled={true}
                        arrowIconVisible={false}
                        className="advanced-filter-option-metric-box"
                    />
                    <S.OperatorWarpper>
                        <SelectedBox
                            className={[
                                'advanced-filter-option-operator-box',
                                !active ? 'disabled' : '',
                            ].join(' ')}
                            selectedOption={
                                SIGN_MAP_BY_VALUE[value?.operator] ??
                                GREATER_THAN
                            }
                            translator={R.prop('sign')}
                            disabled={!active}
                            onClick={() => {
                                const active = Boolean(
                                    this.dropdownVisibleMap[field]
                                );
                                this.setDropdownMap({
                                    key: field,
                                    value: !active,
                                });
                            }}
                        />
                        <DefaultDropdownBox
                            width={56}
                            offSetTop={116}
                            isVisible={this.dropdownVisibleMap[field] ?? false}
                            optionList={OPERATORS}
                            translator={R.prop('sign')}
                            showSelected={false}
                            onConfirm={(operatorValue) => {
                                this.updateAdvancedOptionsValue({
                                    ...value,
                                    operator: operatorValue.value,
                                });
                                this.setDropdownMap({
                                    key: field,
                                    value: false,
                                });
                            }}
                        />
                    </S.OperatorWarpper>

                    <InputField
                        additionalClass="advanced-filter-option-input"
                        value={fixedComma(value?.value ?? 0, '0,0')}
                        onInput={(inputValue) =>
                            this.updateAdvancedOptionsValue({
                                ...value,
                                value: inputValue,
                            })
                        }
                        disabled={!active}
                        cleaner={R.replace(/[^0-9]/g, '')}
                    />
                </S.AdvancedItemWrapper>
            );
        },
    },
    render() {
        const { wrapOptions, renderAdvancedOptions, renderBasicOptions } = this;

        return (
            <C.ComponentWrapper>
                {wrapOptions({
                    hasEditBtn: false,
                    disableClick: false,
                    children: (
                        <S.ListWrapper>
                            {renderBasicOptions()}
                            {renderAdvancedOptions()}
                        </S.ListWrapper>
                    ),
                    icon: <HideIcon class="metric-icon" fill={'black'} />,
                    title: (
                        <S.TitleWrapper>
                            {this.$t('NEW_DASHBOARD.hiding_metric_value')}
                        </S.TitleWrapper>
                    ),
                })}
            </C.ComponentWrapper>
        );
    },
};
